const PAYENumberValidation = (taxnumber) => {
  const reIsValidLength = /^[7]{1}\d{9}$/;

  if (reIsValidLength.test(taxnumber)) {
    return true;
  }
  return false;
};
export default PAYENumberValidation;
